<template>
  <a-form layout="vertical" ref="treatFormRef" :model="retreatFormState" class="retreatForm">
    <div class="setNext">设置下次复诊</div>
    <a-form-item
      label="复诊日期"
      name="reserveDate"
      :rules="{ required: !isCancel, message: '请选择复诊日期' }"
    >
      <a-date-picker
        v-model:value="retreatFormState.reserveDate"
        style="width: 100%"
        placeholder="请选择"
        @change="formChange"
        :disabled-date="disabledDate"
        :showToday="false"
      >
        <template #dateRender="{ current }">
          <div
            :class="[
              'ant-calendar-date',
              calendarCustomStyle(current)
              // appointList.includes(moment(current).format('YYYY-MM-DD'))
              //   ? current > moment()
              //     ? 'calendar-custom'
              //     : 'calendar-custom-passed'
              //   : ''
            ]"
          >
            {{ current.date() }}
          </div>
        </template>
      </a-date-picker>
    </a-form-item>
    <a-form-item
      label="复诊时段"
      name="reserveDateDetail"
      :rules="{ required: !isCancel, message: '请选择复诊时段' }"
    >
      <a-radio-group v-model:value="retreatFormState.reserveDateDetail" @change="formChange">
        <a-radio :value="1">上午</a-radio>
        <a-radio :value="2">下午</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item
      label="复诊方式"
      name="revisitType"
      :rules="{ required: !isCancel, message: '请选择复诊方式' }"
    >
      <a-radio-group v-model:value="retreatFormState.revisitType" @change="formChange">
        <a-radio :value="1">线上问诊</a-radio>
        <a-radio :value="2">门诊就诊</a-radio>
      </a-radio-group>
    </a-form-item>
  </a-form>
  <div class="notreat">
    <a-checkbox v-model:checked="isCancel" @change="hanldeCheck">遵医嘱复诊</a-checkbox>
  </div>
</template>

<script setup>
// import { PlusOutlined } from '@ant-design/icons-vue'
import moment from 'moment'
import { defineProps, ref, defineExpose, reactive, onMounted, computed, defineEmits } from 'vue'
import { queryCureReserveTag } from '@/api/workPlace/retreatment.js'
import { useStore } from 'vuex'
const props = defineProps({
  ucPatientId: { type: String },
  ucDoctorId: { type: String }
})
const ucPatientId = computed(() => props.ucPatientId || curOrder.value.patientInfo?.ucUserId)
const ucDoctorId = computed(() => props.ucDoctorId || curOrder.value.doctorInfo?.ucUserId)
const treatFormRef = ref()
const retreatFormState = reactive({
  reserveDate: '',
  reserveDateDetail: '',
  revisitType: ''
})
const isCancel = ref(false)

const disabledDate = current => {
  return current && current < moment()
}
// 联动复诊信息
const hanldeCheck = () => {
  if (isCancel.value) {
    retreatFormState.reserveDate = ''
    retreatFormState.reserveDateDetail = ''
    retreatFormState.revisitType = ''
  }
}
// 清空遵医嘱复诊
const formChange = () => {
  if (isCancel.value) {
    isCancel.value = false
  }
}

onMounted(() => {
  fetchReverseList()
})

const store = useStore()
const curOrder = computed(() => store.state.workOrder.workOrderGroupInfo)
const appointList = ref([])
const fetchReverseList = () => {
  appointList.value = []
  // apiReverseDateList({
  //   ucDoctorId: curOrder.value.doctorInfo?.ucUserId || null,
  //   ucPatientId: curOrder.value.patientInfo?.ucUserId || null
  // }).then(res => {
  //   appointList.value = res
  // })
  const params = {
    ucPatientId: ucPatientId.value,
    reserveDateMin: null,
    reserveDateMax: null,
    ucDoctorId: ucDoctorId.value,
    prescribe: false
  }
  queryCureReserveTag(params).then(result => {
    // reserveTag 复诊标签：1-高亮 2-置灰， reserveDate
    appointList.value = result
  })
}
const calendarCustomStyle = computed(() => {
  return function (current) {
    let className = null
    className = ''
    const curD = moment(current).format('YYYY-MM-DD')
    const date = appointList.value.find(f => f.reserveDate === curD)
    if (date) {
      className = date.reserveTag === 1 ? 'calendar-custom' : 'calendar-custom-passed'
    }
    return className
  }
})
// 设置表单的值
const setFormState = ctx => {
  const { reserveDate, reserveDateDetail, revisitType } = ctx
  retreatFormState.reserveDate = reserveDate
  retreatFormState.reserveDateDetail = reserveDateDetail
  retreatFormState.revisitType = revisitType
}

// 提交表单
const submitValidQuery = () => {
  return new Promise((resolve, reject) => {
    treatFormRef.value
      .validate()
      .then(() => {
        const result = {
          ...retreatFormState,
          reserveDate: retreatFormState.reserveDate
            ? moment(retreatFormState.reserveDate).format('YYYY-MM-DD 00:00:00')
            : '',
          isCancel: isCancel.value
        }
        resolve(result)
      })
      .catch(err => {
        console.log('err', err)
        reject(err)
      })
  })
}

const resetFields = () => {
  treatFormRef.value.resetFields()
}

const emit = defineEmits(['showSupplement', 'confirmReserce'])

const switchRecordMode = mode => {
  if (mode === 'emit') {
    emit('showSupplement', null)
  } else if (mode === 'select') {
    null
  }
}
function changeDate(data) {
  const { reserveDate, reserveDateDetail, revisitType } = data
  retreatFormState.reserveDate = reserveDate
  retreatFormState.reserveDateDetail = reserveDateDetail
  retreatFormState.revisitType = revisitType
}
defineExpose({
  changeDate,
  submitValidQuery,
  setFormState,
  resetFields
})
</script>

<style lang="scss" scoped>
.retreatForm {
  border-bottom: 1px solid #f0f0f0;
  .add-followup {
    display: flex;
    justify-content: space-between;
  }
  .setNext {
    margin-bottom: 20px;
  }
}
.notreat {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.calendar-custom,
.calendar-custom-passed {
  border: 1px dashed #e3e3e3;
  border-radius: 50%;
}
.ant-calendar-date {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 2px;
}

.ant-calendar {
  width: auto;
}

.calendar-custom::after {
  content: '复';
  width: 16px;
  height: 16px;
  background: #2ed1b5;
  border-radius: 4px;
  position: absolute;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -8px;
  right: -5px;
  font-size: 10px;
}
.calendar-custom-passed::after {
  content: '复';
  width: 16px;
  height: 16px;
  background: #f0f0f0;
  border-radius: 4px;
  position: absolute;
  color: #999999;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -8px;
  right: -5px;
  font-size: 10px;
}

.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date::before {
  width: 30px !important;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
}

.ant-calendar-disabled-cell.ant-calendar-selected-day .ant-calendar-date::before {
  width: 30px !important;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
}
</style>
